import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from '@angular/router';
import { UserService } from '../services/user.service';
import * as Security from '../tokens/roles.tokens';

@Injectable()
export class LeaderGuard implements CanActivate {
  constructor(private userService: UserService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    return this.checkLoggedIn(state.url);
  }

  /**
   * Ensures that the user is logged in as a leader OR as a BYU-I account with the correct role and has a proxied unit selected.
   * If not logged, a redirect to the leader login page is done.
   *
   * @param data The route's data
   * @param url The user's desired URL
   */
  private checkLoggedIn(url: string): boolean {
    if (
      this.userService.isLoggedIn() &&
      (this.userService.userHasRole([Security.ApplicationRoles.byuiAdmin]) ||
        this.userService.userHasRole([Security.ApplicationRoles.byuiLeader]))
    ) {
      if (this.userService.getProxyUnit()) {
        return true;
      }
      // this.router.navigate(['/admin/proxy']);
      this.router.navigate(['/unit-login']);
      return false;
    }

    // TODO not logged in yet; redirect to leader login
    // this.router.navigate(['/login'], { queryParams: { returnUrl: url } });
    return false;
  }
}
